/* tslint:disable */
/* eslint-disable */
/**
 * DOB
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CreateProspectRequest
 */
export interface CreateProspectRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProspectRequest
     */
    'referralCode'?: string;
}
/**
 * 
 * @export
 * @interface CreateProspectResponse
 */
export interface CreateProspectResponse {
    /**
     * 
     * @type {StatusResponse}
     * @memberof CreateProspectResponse
     */
    'status'?: StatusResponse;
    /**
     * 
     * @type {string}
     * @memberof CreateProspectResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface DatiFatca
 */
export interface DatiFatca {
    /**
     * 
     * @type {number}
     * @memberof DatiFatca
     */
    'idIncarico'?: number;
    /**
     * 
     * @type {Array<ResidenzaFiscale>}
     * @memberof DatiFatca
     */
    'listaResidenzaFiscale'?: Array<ResidenzaFiscale>;
    /**
     * 
     * @type {boolean}
     * @memberof DatiFatca
     */
    'residenteUSA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatiFatca
     */
    'tin'?: string;
}
/**
 * 
 * @export
 * @interface Dipendenza
 */
export interface Dipendenza {
    /**
     * 
     * @type {number}
     * @memberof Dipendenza
     */
    'idDomandaDipendenza'?: number;
    /**
     * 
     * @type {number}
     * @memberof Dipendenza
     */
    'idRispostaDipendenza'?: number;
    /**
     * 
     * @type {string}
     * @memberof Dipendenza
     */
    'idRispostaEsternaDipendenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof Dipendenza
     */
    'tipoDipendenza'?: string;
}
/**
 * 
 * @export
 * @interface Domanda
 */
export interface Domanda {
    /**
     * 
     * @type {number}
     * @memberof Domanda
     */
    'idDomanda'?: number;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'testoDomanda'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'subTestoDomanda'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'inputType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'tipoDominio'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'flagDipendenza'?: boolean;
    /**
     * 
     * @type {Array<Dipendenza>}
     * @memberof Domanda
     */
    'listaDipendenze'?: Array<Dipendenza>;
    /**
     * 
     * @type {Array<Risposta>}
     * @memberof Domanda
     */
    'listaRisposte'?: Array<Risposta>;
    /**
     * 
     * @type {StrutturaInternaDomande}
     * @memberof Domanda
     */
    'strutturaInternaDomande'?: StrutturaInternaDomande;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'flagMandatory'?: boolean;
    /**
     * 
     * @type {Array<Validator>}
     * @memberof Domanda
     */
    'validators'?: Array<Validator>;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'pathImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Domanda
     */
    'numDomanda'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'flagCoerenzaIp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Domanda
     */
    'disable'?: boolean;
}
/**
 * 
 * @export
 * @interface DominioEntry
 */
export interface DominioEntry {
    /**
     * 
     * @type {string}
     * @memberof DominioEntry
     */
    'codiceDominio'?: DominioEntryCodiceDominioEnum;
    /**
     * 
     * @type {string}
     * @memberof DominioEntry
     */
    'chiave'?: string;
}

export const DominioEntryCodiceDominioEnum = {
    TipoDocumento: 'DOM_TIPO_DOCUMENTO',
    Cittadinanze: 'DOM_CITTADINANZE',
    TitoloStudio: 'DOM_TITOLO_STUDIO',
    SettoreOccupazioneIAml: 'DOM_SETTORE_OCCUPAZIONE_I_AML',
    SettoreOccupazioneIi: 'DOM_SETTORE_OCCUPAZIONE_II',
    SettoreOccupazioneMifid: 'DOM_SETTORE_OCCUPAZIONE_MIFID',
    ProfessioneAttualeAml: 'DOM_PROFESSIONE_ATTUALE_AML',
    ProfessioneMifid: 'DOM_PROFESSIONE_MIFID',
    NaturaRapporto: 'DOM_NATURA_RAPPORTO',
    StatoCliente: 'DOM_STATO_CLIENTE',
    OrigineVersamento: 'DOM_ORIGINE_VERSAMENTO',
    PercentualeCommissiona: 'DOM_PERCENTUALE_COMMISSIONA',
    Comune: 'DOM_COMUNE',
    ComuneRilascio: 'DOM_COMUNE_RILASCIO',
    ComuneNascita: 'DOM_COMUNE_NASCITA',
    ComuneResidenza: 'DOM_COMUNE_RESIDENZA',
    ComuneContatti: 'DOM_COMUNE_CONTATTI',
    ComuneFirma: 'DOM_COMUNE_FIRMA',
    ComuneDomicilio: 'DOM_COMUNE_DOMICILIO',
    Province: 'DOM_PROVINCE',
    ProvinceRilascio: 'DOM_PROVINCE_RILASCIO',
    ProvinceNascita: 'DOM_PROVINCE_NASCITA',
    ProvinceResidenza: 'DOM_PROVINCE_RESIDENZA',
    ProvinceContatti: 'DOM_PROVINCE_CONTATTI',
    ProvinceProfessione: 'DOM_PROVINCE_PROFESSIONE',
    ProvinceDomicilio: 'DOM_PROVINCE_DOMICILIO',
    Nazioni: 'DOM_NAZIONI',
    NazioneRilascio: 'DOM_NAZIONE_RILASCIO',
    NazioneNascita: 'DOM_NAZIONE_NASCITA',
    NazioneResidenza: 'DOM_NAZIONE_RESIDENZA',
    NazioneContatti: 'DOM_NAZIONE_CONTATTI',
    NazioneResidenzaFiscale: 'DOM_NAZIONE_RESIDENZA_FISCALE',
    NazioneProfessione: 'DOM_NAZIONE_PROFESSIONE',
    NazioneDomicilio: 'DOM_NAZIONE_DOMICILIO',
    Cap: 'DOM_CAP',
    CapResidenza: 'DOM_CAP_RESIDENZA',
    CapContatti: 'DOM_CAP_CONTATTI',
    CapDomicilio: 'DOM_CAP_DOMICILIO',
    Prefissi: 'DOM_PREFISSI',
    Errori: 'DOM_ERRORI',
    TipoRelazione: 'DOM_TIPO_RELAZIONE'
} as const;

export type DominioEntryCodiceDominioEnum = typeof DominioEntryCodiceDominioEnum[keyof typeof DominioEntryCodiceDominioEnum];

/**
 * 
 * @export
 * @interface DominioRequest
 */
export interface DominioRequest {
    /**
     * 
     * @type {string}
     * @memberof DominioRequest
     */
    'idDominio'?: DominioRequestIdDominioEnum;
    /**
     * 
     * @type {Filtro}
     * @memberof DominioRequest
     */
    'filtro'?: Filtro;
}

export const DominioRequestIdDominioEnum = {
    TipoCrs: 'DOM_TIPO_CRS',
    TipoFatca: 'DOM_TIPO_FATCA',
    ClassificazioneCliente: 'DOM_CLASSIFICAZIONE_CLIENTE',
    NaturaRapporto: 'DOM_NATURA_RAPPORTO',
    NaturaGiuridica: 'DOM_NATURA_GIURIDICA',
    ProfessioneAttualeAml: 'DOM_PROFESSIONE_ATTUALE_AML',
    Rae: 'DOM_RAE',
    Sae: 'DOM_SAE',
    Prefissi: 'DOM_PREFISSI',
    SettoreOccupazioneIAml: 'DOM_SETTORE_OCCUPAZIONE_I_AML',
    TipoAnagrafico: 'DOM_TIPO_ANAGRAFICO',
    TipoDocumento: 'DOM_TIPO_DOCUMENTO',
    TitoloStudio: 'DOM_TITOLO_STUDIO',
    ModalitaConoscenza: 'DOM_MODALITA_CONOSCENZA',
    SettoreOccupazioneIi: 'DOM_SETTORE_OCCUPAZIONE_II',
    TipoRelazionePep: 'DOM_TIPO_RELAZIONE_PEP',
    Nazioni: 'DOM_NAZIONI',
    NazioneContatti: 'DOM_NAZIONE_CONTATTI',
    NazioneDomicilio: 'DOM_NAZIONE_DOMICILIO',
    NazioneNascita: 'DOM_NAZIONE_NASCITA',
    NazioneProfessione: 'DOM_NAZIONE_PROFESSIONE',
    NazioneResidenza: 'DOM_NAZIONE_RESIDENZA',
    NazioneResidenzaFiscale: 'DOM_NAZIONE_RESIDENZA_FISCALE',
    NazioneRilascio: 'DOM_NAZIONE_RILASCIO',
    NazioneExtraEu: 'DOM_NAZIONE_EXTRA_EU',
    Cittadinanze: 'DOM_CITTADINANZE',
    Province: 'DOM_PROVINCE',
    ProvinceContatti: 'DOM_PROVINCE_CONTATTI',
    ProvinceDomicilio: 'DOM_PROVINCE_DOMICILIO',
    ProvinceNascita: 'DOM_PROVINCE_NASCITA',
    ProvinceProfessione: 'DOM_PROVINCE_PROFESSIONE',
    ProvinceResidenza: 'DOM_PROVINCE_RESIDENZA',
    ProvinceResidenzaProc: 'DOM_PROVINCE_RESIDENZA_PROC',
    ProvinceRilascio: 'DOM_PROVINCE_RILASCIO',
    ProvinceRilascioProc: 'DOM_PROVINCE_RILASCIO_PROC',
    Comune: 'DOM_COMUNE',
    ComuneRilascio: 'DOM_COMUNE_RILASCIO',
    ComuneRilascioProc: 'DOM_COMUNE_RILASCIO_PROC',
    ComuneNascita: 'DOM_COMUNE_NASCITA',
    ComuneResidenza: 'DOM_COMUNE_RESIDENZA',
    ComuneResidenzaProc: 'DOM_COMUNE_RESIDENZA_PROC',
    ComuneDomicilio: 'DOM_COMUNE_DOMICILIO',
    ComuneContatti: 'DOM_COMUNE_CONTATTI',
    ComuneFirma: 'DOM_COMUNE_FIRMA',
    CapResidenza: 'DOM_CAP_RESIDENZA',
    CapResidenzaProc: 'DOM_CAP_RESIDENZA_PROC',
    CapDomicilio: 'DOM_CAP_DOMICILIO',
    CapContatti: 'DOM_CAP_CONTATTI',
    OrigineVersamento: 'DOM_ORIGINE_VERSAMENTO',
    TipoConsulenza: 'DOM_TIPO_CONSULENZA',
    CaricaRicoperta: 'DOM_CARICA_RICOPERTA',
    PropensioneRischio: 'DOM_PROPENSIONE_RISCHIO',
    ProfiloRischioMifid: 'DOM_PROFILO_RISCHIO_MIFID',
    ProfiloRischioAml: 'DOM_PROFILO_RISCHIO_AML',
    FasciaReddito: 'DOM_FASCIA_REDDITO',
    TenoreVita: 'DOM_TENORE_VITA',
    StatoOnboarding: 'DOM_STATO_ONBOARDING',
    TipoProcesso: 'DOM_TIPO_PROCESSO',
    TipoModulo: 'DOM_TIPO_MODULO',
    TitoloStudioMifid: 'DOM_TITOLO_STUDIO_MIFID',
    SettoreOccupazioneMifid: 'DOM_SETTORE_OCCUPAZIONE_MIFID',
    ProfessioneMifid: 'DOM_PROFESSIONE_MIFID',
    ProfessioneAttualeMifid: 'DOM_PROFESSIONE_ATTUALE_MIFID',
    TipoRelazione: 'DOM_TIPO_RELAZIONE',
    TipoRelazionePg: 'DOM_TIPO_RELAZIONE_PG',
    TipoDocumentoPfRif: 'DOM_TIPO_DOCUMENTO_PF_RIF',
    NazioneRilascioPfRif: 'DOM_NAZIONE_RILASCIO_PF_RIF',
    ProvinceRilascioPfRif: 'DOM_PROVINCE_RILASCIO_PF_RIF',
    ComuneRilascioPfRif: 'DOM_COMUNE_RILASCIO_PF_RIF',
    FormaAssociativa: 'DOM_FORMA_ASSOCIATIVA',
    NazioneSedeLegalePg: 'DOM_NAZIONE_SEDE_LEGALE_PG',
    ProvinceSedeLegalePg: 'DOM_PROVINCE_SEDE_LEGALE_PG',
    ComuneSedeLegalePg: 'DOM_COMUNE_SEDE_LEGALE_PG',
    CapSedeLegalePg: 'DOM_CAP_SEDE_LEGALE_PG',
    NazioneCostituzionePg: 'DOM_NAZIONE_COSTITUZIONE_PG',
    ProvinceCostituzionePg: 'DOM_PROVINCE_COSTITUZIONE_PG',
    ComuneCostituzionePg: 'DOM_COMUNE_COSTITUZIONE_PG',
    AttivitaEsercitata: 'DOM_ATTIVITA_ESERCITATA',
    NazioneNascitaPfRif: 'DOM_NAZIONE_NASCITA_PF_RIF',
    ComuneNascitaPfRif: 'DOM_COMUNE_NASCITA_PF_RIF',
    NazioneResidenzaPfRif: 'DOM_NAZIONE_RESIDENZA_PF_RIF',
    ProvinceResidenzaPfRif: 'DOM_PROVINCE_RESIDENZA_PF_RIF',
    ComuneResidenzaPfRif: 'DOM_COMUNE_RESIDENZA_PF_RIF',
    CapResidenzaPfRif: 'DOM_CAP_RESIDENZA_PF_RIF',
    ProfessioneAttualeAmlPfRif: 'DOM_PROFESSIONE_ATTUALE_AML_PF_RIF',
    ProfessionePrecedenteAmlPfRif: 'DOM_PROFESSIONE_PRECEDENTE_AML_PF_RIF',
    TitoloStudioPfRif: 'DOM_TITOLO_STUDIO_PF_RIF',
    SettoreOccupazioneAmlPfRif: 'DOM_SETTORE_OCCUPAZIONE_AML_PF_RIF',
    ComuneNascitaTe1: 'DOM_COMUNE_NASCITA_TE1',
    ProvinceNascitaTe1: 'DOM_PROVINCE_NASCITA_TE1',
    NazioneNascitaTe1: 'DOM_NAZIONE_NASCITA_TE1',
    NazioneResidenzaTe1: 'DOM_NAZIONE_RESIDENZA_TE1',
    ProvinceResidenzaTe1: 'DOM_PROVINCE_RESIDENZA_TE1',
    ComuneResidenzaTe1: 'DOM_COMUNE_RESIDENZA_TE1',
    CapResidenzaTe1: 'DOM_CAP_RESIDENZA_TE1',
    NazioneComunicazioniTe1: 'DOM_NAZIONE_COMUNICAZIONI_TE1',
    ProvinceComunicazioniTe1: 'DOM_PROVINCE_COMUNICAZIONI_TE1',
    ComuneComunicazioniTe1: 'DOM_COMUNE_COMUNICAZIONI_TE1',
    CapComunicazioniTe1: 'DOM_CAP_COMUNICAZIONI_TE1',
    ComuneNascitaTe2: 'DOM_COMUNE_NASCITA_TE2',
    ProvinceNascitaTe2: 'DOM_PROVINCE_NASCITA_TE2',
    NazioneNascitaTe2: 'DOM_NAZIONE_NASCITA_TE2',
    NazioneResidenzaTe2: 'DOM_NAZIONE_RESIDENZA_TE2',
    ProvinceResidenzaTe2: 'DOM_PROVINCE_RESIDENZA_TE2',
    ComuneResidenzaTe2: 'DOM_COMUNE_RESIDENZA_TE2',
    CapResidenzaTe2: 'DOM_CAP_RESIDENZA_TE2',
    NazioneComunicazioniTe2: 'DOM_NAZIONE_COMUNICAZIONI_TE2',
    ProvinceComunicazioniTe2: 'DOM_PROVINCE_COMUNICAZIONI_TE2',
    ComuneComunicazioniTe2: 'DOM_COMUNE_COMUNICAZIONI_TE2',
    CapComunicazioniTe2: 'DOM_CAP_COMUNICAZIONI_TE2',
    ComuneNascitaTe3: 'DOM_COMUNE_NASCITA_TE3',
    ProvinceNascitaTe3: 'DOM_PROVINCE_NASCITA_TE3',
    NazioneNascitaTe3: 'DOM_NAZIONE_NASCITA_TE3',
    NazioneResidenzaTe3: 'DOM_NAZIONE_RESIDENZA_TE3',
    ProvinceResidenzaTe3: 'DOM_PROVINCE_RESIDENZA_TE3',
    ComuneResidenzaTe3: 'DOM_COMUNE_RESIDENZA_TE3',
    CapResidenzaTe3: 'DOM_CAP_RESIDENZA_TE3',
    NazioneComunicazioniTe3: 'DOM_NAZIONE_COMUNICAZIONI_TE3',
    ProvinceComunicazioniTe3: 'DOM_PROVINCE_COMUNICAZIONI_TE3',
    ComuneComunicazioniTe3: 'DOM_COMUNE_COMUNICAZIONI_TE3',
    CapComunicazioniTe3: 'DOM_CAP_COMUNICAZIONI_TE3',
    ComuneNascitaTe4: 'DOM_COMUNE_NASCITA_TE4',
    ProvinceNascitaTe4: 'DOM_PROVINCE_NASCITA_TE4',
    NazioneNascitaTe4: 'DOM_NAZIONE_NASCITA_TE4',
    NazioneResidenzaTe4: 'DOM_NAZIONE_RESIDENZA_TE4',
    ProvinceResidenzaTe4: 'DOM_PROVINCE_RESIDENZA_TE4',
    ComuneResidenzaTe4: 'DOM_COMUNE_RESIDENZA_TE4',
    CapResidenzaTe4: 'DOM_CAP_RESIDENZA_TE4',
    NazioneComunicazioniTe4: 'DOM_NAZIONE_COMUNICAZIONI_TE4',
    ProvinceComunicazioniTe4: 'DOM_PROVINCE_COMUNICAZIONI_TE4',
    ComuneComunicazioniTe4: 'DOM_COMUNE_COMUNICAZIONI_TE4',
    CapComunicazioniTe4: 'DOM_CAP_COMUNICAZIONI_TE4',
    ComuneNascitaTe5: 'DOM_COMUNE_NASCITA_TE5',
    ProvinceNascitaTe5: 'DOM_PROVINCE_NASCITA_TE5',
    NazioneNascitaTe5: 'DOM_NAZIONE_NASCITA_TE5',
    NazioneResidenzaTe5: 'DOM_NAZIONE_RESIDENZA_TE5',
    ProvinceResidenzaTe5: 'DOM_PROVINCE_RESIDENZA_TE5',
    ComuneResidenzaTe5: 'DOM_COMUNE_RESIDENZA_TE5',
    CapResidenzaTe5: 'DOM_CAP_RESIDENZA_TE5',
    NazioneComunicazioniTe5: 'DOM_NAZIONE_COMUNICAZIONI_TE5',
    ProvinceComunicazioniTe5: 'DOM_PROVINCE_COMUNICAZIONI_TE5',
    ComuneComunicazioniTe5: 'DOM_COMUNE_COMUNICAZIONI_TE5',
    CapComunicazioniTe5: 'DOM_CAP_COMUNICAZIONI_TE5'
} as const;

export type DominioRequestIdDominioEnum = typeof DominioRequestIdDominioEnum[keyof typeof DominioRequestIdDominioEnum];

/**
 * 
 * @export
 * @interface DominioResponse
 */
export interface DominioResponse {
    /**
     * 
     * @type {string}
     * @memberof DominioResponse
     */
    'idDominio'?: DominioResponseIdDominioEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DominioResponse
     */
    'valoriDominio'?: { [key: string]: string; };
}

export const DominioResponseIdDominioEnum = {
    TipoCrs: 'DOM_TIPO_CRS',
    TipoFatca: 'DOM_TIPO_FATCA',
    ClassificazioneCliente: 'DOM_CLASSIFICAZIONE_CLIENTE',
    NaturaRapporto: 'DOM_NATURA_RAPPORTO',
    NaturaGiuridica: 'DOM_NATURA_GIURIDICA',
    ProfessioneAttualeAml: 'DOM_PROFESSIONE_ATTUALE_AML',
    Rae: 'DOM_RAE',
    Sae: 'DOM_SAE',
    Prefissi: 'DOM_PREFISSI',
    SettoreOccupazioneIAml: 'DOM_SETTORE_OCCUPAZIONE_I_AML',
    TipoAnagrafico: 'DOM_TIPO_ANAGRAFICO',
    TipoDocumento: 'DOM_TIPO_DOCUMENTO',
    TitoloStudio: 'DOM_TITOLO_STUDIO',
    ModalitaConoscenza: 'DOM_MODALITA_CONOSCENZA',
    SettoreOccupazioneIi: 'DOM_SETTORE_OCCUPAZIONE_II',
    TipoRelazionePep: 'DOM_TIPO_RELAZIONE_PEP',
    Nazioni: 'DOM_NAZIONI',
    NazioneContatti: 'DOM_NAZIONE_CONTATTI',
    NazioneDomicilio: 'DOM_NAZIONE_DOMICILIO',
    NazioneNascita: 'DOM_NAZIONE_NASCITA',
    NazioneProfessione: 'DOM_NAZIONE_PROFESSIONE',
    NazioneResidenza: 'DOM_NAZIONE_RESIDENZA',
    NazioneResidenzaFiscale: 'DOM_NAZIONE_RESIDENZA_FISCALE',
    NazioneRilascio: 'DOM_NAZIONE_RILASCIO',
    NazioneExtraEu: 'DOM_NAZIONE_EXTRA_EU',
    Cittadinanze: 'DOM_CITTADINANZE',
    Province: 'DOM_PROVINCE',
    ProvinceContatti: 'DOM_PROVINCE_CONTATTI',
    ProvinceDomicilio: 'DOM_PROVINCE_DOMICILIO',
    ProvinceNascita: 'DOM_PROVINCE_NASCITA',
    ProvinceProfessione: 'DOM_PROVINCE_PROFESSIONE',
    ProvinceResidenza: 'DOM_PROVINCE_RESIDENZA',
    ProvinceResidenzaProc: 'DOM_PROVINCE_RESIDENZA_PROC',
    ProvinceRilascio: 'DOM_PROVINCE_RILASCIO',
    ProvinceRilascioProc: 'DOM_PROVINCE_RILASCIO_PROC',
    Comune: 'DOM_COMUNE',
    ComuneRilascio: 'DOM_COMUNE_RILASCIO',
    ComuneRilascioProc: 'DOM_COMUNE_RILASCIO_PROC',
    ComuneNascita: 'DOM_COMUNE_NASCITA',
    ComuneResidenza: 'DOM_COMUNE_RESIDENZA',
    ComuneResidenzaProc: 'DOM_COMUNE_RESIDENZA_PROC',
    ComuneDomicilio: 'DOM_COMUNE_DOMICILIO',
    ComuneContatti: 'DOM_COMUNE_CONTATTI',
    ComuneFirma: 'DOM_COMUNE_FIRMA',
    CapResidenza: 'DOM_CAP_RESIDENZA',
    CapResidenzaProc: 'DOM_CAP_RESIDENZA_PROC',
    CapDomicilio: 'DOM_CAP_DOMICILIO',
    CapContatti: 'DOM_CAP_CONTATTI',
    OrigineVersamento: 'DOM_ORIGINE_VERSAMENTO',
    TipoConsulenza: 'DOM_TIPO_CONSULENZA',
    CaricaRicoperta: 'DOM_CARICA_RICOPERTA',
    PropensioneRischio: 'DOM_PROPENSIONE_RISCHIO',
    ProfiloRischioMifid: 'DOM_PROFILO_RISCHIO_MIFID',
    ProfiloRischioAml: 'DOM_PROFILO_RISCHIO_AML',
    FasciaReddito: 'DOM_FASCIA_REDDITO',
    TenoreVita: 'DOM_TENORE_VITA',
    StatoOnboarding: 'DOM_STATO_ONBOARDING',
    TipoProcesso: 'DOM_TIPO_PROCESSO',
    TipoModulo: 'DOM_TIPO_MODULO',
    TitoloStudioMifid: 'DOM_TITOLO_STUDIO_MIFID',
    SettoreOccupazioneMifid: 'DOM_SETTORE_OCCUPAZIONE_MIFID',
    ProfessioneMifid: 'DOM_PROFESSIONE_MIFID',
    ProfessioneAttualeMifid: 'DOM_PROFESSIONE_ATTUALE_MIFID',
    TipoRelazione: 'DOM_TIPO_RELAZIONE',
    TipoRelazionePg: 'DOM_TIPO_RELAZIONE_PG',
    TipoDocumentoPfRif: 'DOM_TIPO_DOCUMENTO_PF_RIF',
    NazioneRilascioPfRif: 'DOM_NAZIONE_RILASCIO_PF_RIF',
    ProvinceRilascioPfRif: 'DOM_PROVINCE_RILASCIO_PF_RIF',
    ComuneRilascioPfRif: 'DOM_COMUNE_RILASCIO_PF_RIF',
    FormaAssociativa: 'DOM_FORMA_ASSOCIATIVA',
    NazioneSedeLegalePg: 'DOM_NAZIONE_SEDE_LEGALE_PG',
    ProvinceSedeLegalePg: 'DOM_PROVINCE_SEDE_LEGALE_PG',
    ComuneSedeLegalePg: 'DOM_COMUNE_SEDE_LEGALE_PG',
    CapSedeLegalePg: 'DOM_CAP_SEDE_LEGALE_PG',
    NazioneCostituzionePg: 'DOM_NAZIONE_COSTITUZIONE_PG',
    ProvinceCostituzionePg: 'DOM_PROVINCE_COSTITUZIONE_PG',
    ComuneCostituzionePg: 'DOM_COMUNE_COSTITUZIONE_PG',
    AttivitaEsercitata: 'DOM_ATTIVITA_ESERCITATA',
    NazioneNascitaPfRif: 'DOM_NAZIONE_NASCITA_PF_RIF',
    ComuneNascitaPfRif: 'DOM_COMUNE_NASCITA_PF_RIF',
    NazioneResidenzaPfRif: 'DOM_NAZIONE_RESIDENZA_PF_RIF',
    ProvinceResidenzaPfRif: 'DOM_PROVINCE_RESIDENZA_PF_RIF',
    ComuneResidenzaPfRif: 'DOM_COMUNE_RESIDENZA_PF_RIF',
    CapResidenzaPfRif: 'DOM_CAP_RESIDENZA_PF_RIF',
    ProfessioneAttualeAmlPfRif: 'DOM_PROFESSIONE_ATTUALE_AML_PF_RIF',
    ProfessionePrecedenteAmlPfRif: 'DOM_PROFESSIONE_PRECEDENTE_AML_PF_RIF',
    TitoloStudioPfRif: 'DOM_TITOLO_STUDIO_PF_RIF',
    SettoreOccupazioneAmlPfRif: 'DOM_SETTORE_OCCUPAZIONE_AML_PF_RIF',
    ComuneNascitaTe1: 'DOM_COMUNE_NASCITA_TE1',
    ProvinceNascitaTe1: 'DOM_PROVINCE_NASCITA_TE1',
    NazioneNascitaTe1: 'DOM_NAZIONE_NASCITA_TE1',
    NazioneResidenzaTe1: 'DOM_NAZIONE_RESIDENZA_TE1',
    ProvinceResidenzaTe1: 'DOM_PROVINCE_RESIDENZA_TE1',
    ComuneResidenzaTe1: 'DOM_COMUNE_RESIDENZA_TE1',
    CapResidenzaTe1: 'DOM_CAP_RESIDENZA_TE1',
    NazioneComunicazioniTe1: 'DOM_NAZIONE_COMUNICAZIONI_TE1',
    ProvinceComunicazioniTe1: 'DOM_PROVINCE_COMUNICAZIONI_TE1',
    ComuneComunicazioniTe1: 'DOM_COMUNE_COMUNICAZIONI_TE1',
    CapComunicazioniTe1: 'DOM_CAP_COMUNICAZIONI_TE1',
    ComuneNascitaTe2: 'DOM_COMUNE_NASCITA_TE2',
    ProvinceNascitaTe2: 'DOM_PROVINCE_NASCITA_TE2',
    NazioneNascitaTe2: 'DOM_NAZIONE_NASCITA_TE2',
    NazioneResidenzaTe2: 'DOM_NAZIONE_RESIDENZA_TE2',
    ProvinceResidenzaTe2: 'DOM_PROVINCE_RESIDENZA_TE2',
    ComuneResidenzaTe2: 'DOM_COMUNE_RESIDENZA_TE2',
    CapResidenzaTe2: 'DOM_CAP_RESIDENZA_TE2',
    NazioneComunicazioniTe2: 'DOM_NAZIONE_COMUNICAZIONI_TE2',
    ProvinceComunicazioniTe2: 'DOM_PROVINCE_COMUNICAZIONI_TE2',
    ComuneComunicazioniTe2: 'DOM_COMUNE_COMUNICAZIONI_TE2',
    CapComunicazioniTe2: 'DOM_CAP_COMUNICAZIONI_TE2',
    ComuneNascitaTe3: 'DOM_COMUNE_NASCITA_TE3',
    ProvinceNascitaTe3: 'DOM_PROVINCE_NASCITA_TE3',
    NazioneNascitaTe3: 'DOM_NAZIONE_NASCITA_TE3',
    NazioneResidenzaTe3: 'DOM_NAZIONE_RESIDENZA_TE3',
    ProvinceResidenzaTe3: 'DOM_PROVINCE_RESIDENZA_TE3',
    ComuneResidenzaTe3: 'DOM_COMUNE_RESIDENZA_TE3',
    CapResidenzaTe3: 'DOM_CAP_RESIDENZA_TE3',
    NazioneComunicazioniTe3: 'DOM_NAZIONE_COMUNICAZIONI_TE3',
    ProvinceComunicazioniTe3: 'DOM_PROVINCE_COMUNICAZIONI_TE3',
    ComuneComunicazioniTe3: 'DOM_COMUNE_COMUNICAZIONI_TE3',
    CapComunicazioniTe3: 'DOM_CAP_COMUNICAZIONI_TE3',
    ComuneNascitaTe4: 'DOM_COMUNE_NASCITA_TE4',
    ProvinceNascitaTe4: 'DOM_PROVINCE_NASCITA_TE4',
    NazioneNascitaTe4: 'DOM_NAZIONE_NASCITA_TE4',
    NazioneResidenzaTe4: 'DOM_NAZIONE_RESIDENZA_TE4',
    ProvinceResidenzaTe4: 'DOM_PROVINCE_RESIDENZA_TE4',
    ComuneResidenzaTe4: 'DOM_COMUNE_RESIDENZA_TE4',
    CapResidenzaTe4: 'DOM_CAP_RESIDENZA_TE4',
    NazioneComunicazioniTe4: 'DOM_NAZIONE_COMUNICAZIONI_TE4',
    ProvinceComunicazioniTe4: 'DOM_PROVINCE_COMUNICAZIONI_TE4',
    ComuneComunicazioniTe4: 'DOM_COMUNE_COMUNICAZIONI_TE4',
    CapComunicazioniTe4: 'DOM_CAP_COMUNICAZIONI_TE4',
    ComuneNascitaTe5: 'DOM_COMUNE_NASCITA_TE5',
    ProvinceNascitaTe5: 'DOM_PROVINCE_NASCITA_TE5',
    NazioneNascitaTe5: 'DOM_NAZIONE_NASCITA_TE5',
    NazioneResidenzaTe5: 'DOM_NAZIONE_RESIDENZA_TE5',
    ProvinceResidenzaTe5: 'DOM_PROVINCE_RESIDENZA_TE5',
    ComuneResidenzaTe5: 'DOM_COMUNE_RESIDENZA_TE5',
    CapResidenzaTe5: 'DOM_CAP_RESIDENZA_TE5',
    NazioneComunicazioniTe5: 'DOM_NAZIONE_COMUNICAZIONI_TE5',
    ProvinceComunicazioniTe5: 'DOM_PROVINCE_COMUNICAZIONI_TE5',
    ComuneComunicazioniTe5: 'DOM_COMUNE_COMUNICAZIONI_TE5',
    CapComunicazioniTe5: 'DOM_CAP_COMUNICAZIONI_TE5'
} as const;

export type DominioResponseIdDominioEnum = typeof DominioResponseIdDominioEnum[keyof typeof DominioResponseIdDominioEnum];

/**
 * 
 * @export
 * @interface DominioRisposte
 */
export interface DominioRisposte {
    /**
     * 
     * @type {string}
     * @memberof DominioRisposte
     */
    'descrizione'?: string;
    /**
     * 
     * @type {Array<Risposta>}
     * @memberof DominioRisposte
     */
    'risposte'?: Array<Risposta>;
}
/**
 * 
 * @export
 * @interface ElencoDominioRequest
 */
export interface ElencoDominioRequest {
    /**
     * 
     * @type {Array<DominioRequest>}
     * @memberof ElencoDominioRequest
     */
    'listaDomini'?: Array<DominioRequest>;
}
/**
 * 
 * @export
 * @interface ElencoDominioResponse
 */
export interface ElencoDominioResponse {
    /**
     * 
     * @type {Array<DominioResponse>}
     * @memberof ElencoDominioResponse
     */
    'listaDomini'?: Array<DominioResponse>;
    /**
     * 
     * @type {StatusResponse}
     * @memberof ElencoDominioResponse
     */
    'statusResponse'?: StatusResponse;
}
/**
 * 
 * @export
 * @interface Filtro
 */
export interface Filtro {
    /**
     * 
     * @type {string}
     * @memberof Filtro
     */
    'codice'?: string;
}
/**
 * 
 * @export
 * @interface FinalizeOnboardingResponse
 */
export interface FinalizeOnboardingResponse {
    /**
     * 
     * @type {string}
     * @memberof FinalizeOnboardingResponse
     */
    'referralCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FinalizeOnboardingResponse
     */
    'sessionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FinalizeOnboardingResponse
     */
    'passAudioTranscription'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FinalizeOnboardingResponse
     */
    'passFaceComparision'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FinalizeOnboardingResponse
     */
    'passDocumentRecognition'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FinalizeOnboardingResponse
     */
    'passDocumentValidateResult'?: boolean;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponse
 */
export interface FormThematicAreaResponse {
    /**
     * 
     * @type {Array<FormThematicAreaResponseThematicAreaResponse>}
     * @memberof FormThematicAreaResponse
     */
    'thematicAreaList'?: Array<FormThematicAreaResponseThematicAreaResponse>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponse
     */
    'formCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponse
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponse
     */
    'formDescription'?: string;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseQuestionOptionResponse
 */
export interface FormThematicAreaResponseQuestionOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionOptionResponse
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionOptionResponse
     */
    'text'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionOptionResponse
     */
    'conditionList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseQuestionResponse
 */
export interface FormThematicAreaResponseQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'conditionList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'help'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'readonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionOptionResponse>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'questionOptionList'?: Array<FormThematicAreaResponseQuestionOptionResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'imageList'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'valorized'?: boolean;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionsTableResponse>}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'questionTableList'?: Array<FormThematicAreaResponseQuestionsTableResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionResponse
     */
    'compact'?: boolean;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseQuestionsTableResponse
 */
export interface FormThematicAreaResponseQuestionsTableResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'conditionList'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'help'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'readonly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'visible'?: boolean;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionOptionResponse>}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'questionOptionList'?: Array<FormThematicAreaResponseQuestionOptionResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'imageList'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'clearOthers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormThematicAreaResponseQuestionsTableResponse
     */
    'setByOthers'?: boolean;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseSectionResponse
 */
export interface FormThematicAreaResponseSectionResponse {
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'sectionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'text'?: string;
    /**
     * 
     * @type {Array<FormThematicAreaResponseQuestionResponse>}
     * @memberof FormThematicAreaResponseSectionResponse
     */
    'questionList'?: Array<FormThematicAreaResponseQuestionResponse>;
}
/**
 * 
 * @export
 * @interface FormThematicAreaResponseThematicAreaResponse
 */
export interface FormThematicAreaResponseThematicAreaResponse {
    /**
     * 
     * @type {Array<FormThematicAreaResponseSectionResponse>}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'sectionList'?: Array<FormThematicAreaResponseSectionResponse>;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'thematicAreaCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormThematicAreaResponseThematicAreaResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface MifidCompileTypeRequest
 */
export interface MifidCompileTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof MifidCompileTypeRequest
     */
    'compileType'?: string;
}
/**
 * 
 * @export
 * @interface PostMifidExternalMassiveRequest
 */
export interface PostMifidExternalMassiveRequest {
    /**
     * 
     * @type {Array<QuestionnaireResponseAnswerResponse>}
     * @memberof PostMifidExternalMassiveRequest
     */
    'response'?: Array<QuestionnaireResponseAnswerResponse>;
}
/**
 * 
 * @export
 * @interface PostMifidExternalResponse
 */
export interface PostMifidExternalResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof PostMifidExternalResponse
     */
    'incoeherenceList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PraticaSelf
 */
export interface PraticaSelf {
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'codicePratica'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'codicePromoter'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'statoPratica'?: string;
    /**
     * 
     * @type {number}
     * @memberof PraticaSelf
     */
    'processStateCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'codiceCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'compileType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'meetingDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PraticaSelf
     */
    'isMifidEnable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraticaSelf
     */
    'toSign'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PraticaSelf
     */
    'flagProfilaturaMifid'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PraticaSelf
     */
    'attemptsLeftCounter'?: number;
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'prospectCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PraticaSelf
     */
    'bundleCode'?: string;
}
/**
 * 
 * @export
 * @interface PraticaSelfResponse
 */
export interface PraticaSelfResponse {
    /**
     * 
     * @type {StatusResponse}
     * @memberof PraticaSelfResponse
     */
    'statusResponse'?: StatusResponse;
    /**
     * 
     * @type {PraticaSelf}
     * @memberof PraticaSelfResponse
     */
    'pratica'?: PraticaSelf;
}
/**
 * 
 * @export
 * @interface ProfiloCliente
 */
export interface ProfiloCliente {
    /**
     * 
     * @type {string}
     * @memberof ProfiloCliente
     */
    'idCliente'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfiloCliente
     */
    'idQuestionario'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfiloCliente
     */
    'profiloEsperienza'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloCliente
     */
    'profiloRischio'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloCliente
     */
    'profiloObiettivo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfiloCliente
     */
    'dataScadenza'?: string;
}
/**
 * 
 * @export
 * @interface QuestionnaireResponseAnswerResponse
 */
export interface QuestionnaireResponseAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireResponseAnswerResponse
     */
    'questionCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireResponseAnswerResponse
     */
    'questionTableId'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireResponseAnswerResponse
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface ReferralCodeByPraticaResponse
 */
export interface ReferralCodeByPraticaResponse {
    /**
     * 
     * @type {StatusResponse}
     * @memberof ReferralCodeByPraticaResponse
     */
    'response'?: StatusResponse;
    /**
     * 
     * @type {ReferralCodeResponse}
     * @memberof ReferralCodeByPraticaResponse
     */
    'body'?: ReferralCodeResponse;
}
/**
 * 
 * @export
 * @interface ReferralCodeResponse
 */
export interface ReferralCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'cognome'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'nome'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'codiceFiscale'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'prefisso'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'telefono'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'idPromoter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'referralCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'creationTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'expiresOn'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralCodeResponse
     */
    'isHolder'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'workflowName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'sessionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'sessionStatus'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralCodeResponse
     */
    'documentRecognition'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralCodeResponse
     */
    'faceComparison'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralCodeResponse
     */
    'audioTranscription'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'idPractice'?: string;
}
/**
 * 
 * @export
 * @interface ResidenzaFiscale
 */
export interface ResidenzaFiscale {
    /**
     * 
     * @type {DominioEntry}
     * @memberof ResidenzaFiscale
     */
    'codiceNazione'?: DominioEntry;
    /**
     * 
     * @type {string}
     * @memberof ResidenzaFiscale
     */
    'codiceFiscaleEstero'?: string;
}
/**
 * 
 * @export
 * @interface Risposta
 */
export interface Risposta {
    /**
     * 
     * @type {number}
     * @memberof Risposta
     */
    'idRisposta'?: number;
    /**
     * 
     * @type {string}
     * @memberof Risposta
     */
    'descRisposta'?: string;
    /**
     * 
     * @type {string}
     * @memberof Risposta
     */
    'descSubRisposta'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Risposta
     */
    'flagDipendenza'?: boolean;
    /**
     * 
     * @type {Array<Dipendenza>}
     * @memberof Risposta
     */
    'listaDipendenze'?: Array<Dipendenza>;
    /**
     * 
     * @type {boolean}
     * @memberof Risposta
     */
    'flagCoerenzaIp'?: boolean;
}
/**
 * 
 * @export
 * @interface RisposteSezione
 */
export interface RisposteSezione {
    /**
     * 
     * @type {string}
     * @memberof RisposteSezione
     */
    'idSezione'?: RisposteSezioneIdSezioneEnum;
    /**
     * 
     * @type {Array<Domanda>}
     * @memberof RisposteSezione
     */
    'listaDomande'?: Array<Domanda>;
}

export const RisposteSezioneIdSezioneEnum = {
    ConoscenzaEsperienza: 'CONOSCENZA_ESPERIENZA',
    Investimento: 'INVESTIMENTO',
    Finanziaria: 'FINANZIARIA',
    Altro: 'ALTRO',
    Header: 'HEADER',
    SezCommon: 'SEZ_COMMON',
    InvestimentoLight: 'INVESTIMENTO_LIGHT',
    AltroLight: 'ALTRO_LIGHT',
    HeaderLight: 'HEADER_LIGHT',
    HeaderPf: 'HEADER_PF',
    Anagrafica: 'ANAGRAFICA',
    ConoscenzaEsperienzaPf: 'CONOSCENZA_ESPERIENZA_PF',
    FinanziariaPf: 'FINANZIARIA_PF',
    TolleranzaOscillazione: 'TOLLERANZA_OSCILLAZIONE',
    InvestimentoPf: 'INVESTIMENTO_PF',
    InvestimentiEsgPf: 'INVESTIMENTI_ESG_PF',
    EducazioneFinanziaria: 'EDUCAZIONE_FINANZIARIA',
    HeaderPg: 'HEADER_PG',
    ConoscenzaEsperienzaPg: 'CONOSCENZA_ESPERIENZA_PG',
    FinanziariaPg: 'FINANZIARIA_PG',
    TolleranzaOscillazionePg: 'TOLLERANZA_OSCILLAZIONE_PG',
    InvestimentoPg: 'INVESTIMENTO_PG',
    InvestimentiEsgPg: 'INVESTIMENTI_ESG_PG',
    EducazioneFinanziariaPg: 'EDUCAZIONE_FINANZIARIA_PG',
    HeaderPd: 'HEADER_PD',
    TolleranzaOscillazionePd: 'TOLLERANZA_OSCILLAZIONE_PD',
    InvestimentoPd: 'INVESTIMENTO_PD',
    InvestimentiEsgPd: 'INVESTIMENTI_ESG_PD',
    EducazioneFinanziariaPd: 'EDUCAZIONE_FINANZIARIA_PD',
    FinanziariaPd: 'FINANZIARIA_PD'
} as const;

export type RisposteSezioneIdSezioneEnum = typeof RisposteSezioneIdSezioneEnum[keyof typeof RisposteSezioneIdSezioneEnum];

/**
 * 
 * @export
 * @interface Sezione
 */
export interface Sezione {
    /**
     * 
     * @type {string}
     * @memberof Sezione
     */
    'idSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Sezione
     */
    'descSezione'?: string;
    /**
     * 
     * @type {Array<Domanda>}
     * @memberof Sezione
     */
    'listaDomande'?: Array<Domanda>;
}
/**
 * 
 * @export
 * @interface StatusResponse
 */
export interface StatusResponse {
    /**
     * 
     * @type {string}
     * @memberof StatusResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusResponse
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface StrutturaInternaDomande
 */
export interface StrutturaInternaDomande {
    /**
     * 
     * @type {Array<Domanda>}
     * @memberof StrutturaInternaDomande
     */
    'domande'?: Array<Domanda>;
    /**
     * 
     * @type {Array<DominioRisposte>}
     * @memberof StrutturaInternaDomande
     */
    'listaDominiRisposte'?: Array<DominioRisposte>;
}
/**
 * 
 * @export
 * @interface SurveyError
 */
export interface SurveyError {
    /**
     * 
     * @type {string}
     * @memberof SurveyError
     */
    'codice'?: string;
    /**
     * 
     * @type {Set<number>}
     * @memberof SurveyError
     */
    'idDomande'?: Set<number>;
}
/**
 * 
 * @export
 * @interface SurveyRisposte
 */
export interface SurveyRisposte {
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposte
     */
    'idCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposte
     */
    'idIncarico'?: string;
    /**
     * 
     * @type {Array<Domanda>}
     * @memberof SurveyRisposte
     */
    'listaDomande'?: Array<Domanda>;
    /**
     * 
     * @type {StatusResponse}
     * @memberof SurveyRisposte
     */
    'statusResponse'?: StatusResponse;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyRisposte
     */
    'flagProfilatura'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposte
     */
    'profiloRischio'?: string;
    /**
     * 
     * @type {Array<SurveyError>}
     * @memberof SurveyRisposte
     */
    'errori'?: Array<SurveyError>;
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposte
     */
    'subjectType'?: SurveyRisposteSubjectTypeEnum;
    /**
     * 
     * @type {ProfiloCliente}
     * @memberof SurveyRisposte
     */
    'profiloCliente'?: ProfiloCliente;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyRisposte
     */
    'completed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposte
     */
    'idServizio'?: SurveyRisposteIdServizioEnum;
}

export const SurveyRisposteSubjectTypeEnum = {
    Procurator: 'PROCURATOR',
    PhysicalSubject: 'PHYSICAL_SUBJECT',
    LegalPerson: 'LEGAL_PERSON',
    PhysicalSubjectReference: 'PHYSICAL_SUBJECT_REFERENCE'
} as const;

export type SurveyRisposteSubjectTypeEnum = typeof SurveyRisposteSubjectTypeEnum[keyof typeof SurveyRisposteSubjectTypeEnum];
export const SurveyRisposteIdServizioEnum = {
    ConoscenzaEsperienza: 'CONOSCENZA_ESPERIENZA',
    Investimento: 'INVESTIMENTO',
    Finanziaria: 'FINANZIARIA',
    Altro: 'ALTRO',
    Header: 'HEADER',
    SezCommon: 'SEZ_COMMON',
    InvestimentoLight: 'INVESTIMENTO_LIGHT',
    AltroLight: 'ALTRO_LIGHT',
    HeaderLight: 'HEADER_LIGHT',
    HeaderPf: 'HEADER_PF',
    Anagrafica: 'ANAGRAFICA',
    ConoscenzaEsperienzaPf: 'CONOSCENZA_ESPERIENZA_PF',
    FinanziariaPf: 'FINANZIARIA_PF',
    TolleranzaOscillazione: 'TOLLERANZA_OSCILLAZIONE',
    InvestimentoPf: 'INVESTIMENTO_PF',
    InvestimentiEsgPf: 'INVESTIMENTI_ESG_PF',
    EducazioneFinanziaria: 'EDUCAZIONE_FINANZIARIA',
    HeaderPg: 'HEADER_PG',
    ConoscenzaEsperienzaPg: 'CONOSCENZA_ESPERIENZA_PG',
    FinanziariaPg: 'FINANZIARIA_PG',
    TolleranzaOscillazionePg: 'TOLLERANZA_OSCILLAZIONE_PG',
    InvestimentoPg: 'INVESTIMENTO_PG',
    InvestimentiEsgPg: 'INVESTIMENTI_ESG_PG',
    EducazioneFinanziariaPg: 'EDUCAZIONE_FINANZIARIA_PG',
    HeaderPd: 'HEADER_PD',
    TolleranzaOscillazionePd: 'TOLLERANZA_OSCILLAZIONE_PD',
    InvestimentoPd: 'INVESTIMENTO_PD',
    InvestimentiEsgPd: 'INVESTIMENTI_ESG_PD',
    EducazioneFinanziariaPd: 'EDUCAZIONE_FINANZIARIA_PD',
    FinanziariaPd: 'FINANZIARIA_PD'
} as const;

export type SurveyRisposteIdServizioEnum = typeof SurveyRisposteIdServizioEnum[keyof typeof SurveyRisposteIdServizioEnum];

/**
 * 
 * @export
 * @interface SurveyRisposteFull
 */
export interface SurveyRisposteFull {
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposteFull
     */
    'idCliente'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposteFull
     */
    'idIncarico'?: string;
    /**
     * 
     * @type {Array<RisposteSezione>}
     * @memberof SurveyRisposteFull
     */
    'risposteSezione'?: Array<RisposteSezione>;
    /**
     * 
     * @type {StatusResponse}
     * @memberof SurveyRisposteFull
     */
    'statusResponse'?: StatusResponse;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyRisposteFull
     */
    'flagProfilatura'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposteFull
     */
    'profiloRischio'?: string;
    /**
     * 
     * @type {Array<SurveyError>}
     * @memberof SurveyRisposteFull
     */
    'errori'?: Array<SurveyError>;
    /**
     * 
     * @type {string}
     * @memberof SurveyRisposteFull
     */
    'subjectType'?: SurveyRisposteFullSubjectTypeEnum;
    /**
     * 
     * @type {ProfiloCliente}
     * @memberof SurveyRisposteFull
     */
    'profiloCliente'?: ProfiloCliente;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyRisposteFull
     */
    'completed'?: boolean;
}

export const SurveyRisposteFullSubjectTypeEnum = {
    Procurator: 'PROCURATOR',
    PhysicalSubject: 'PHYSICAL_SUBJECT',
    LegalPerson: 'LEGAL_PERSON',
    PhysicalSubjectReference: 'PHYSICAL_SUBJECT_REFERENCE'
} as const;

export type SurveyRisposteFullSubjectTypeEnum = typeof SurveyRisposteFullSubjectTypeEnum[keyof typeof SurveyRisposteFullSubjectTypeEnum];

/**
 * 
 * @export
 * @interface Template
 */
export interface Template {
    /**
     * 
     * @type {string}
     * @memberof Template
     */
    'titoloSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Template
     */
    'titoloSubSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Template
     */
    'titoloSubSubSezione'?: string;
    /**
     * 
     * @type {string}
     * @memberof Template
     */
    'labelClienteNonProfilato'?: string;
    /**
     * 
     * @type {Array<Sezione>}
     * @memberof Template
     */
    'sezioni'?: Array<Sezione>;
    /**
     * 
     * @type {StatusResponse}
     * @memberof Template
     */
    'statusResponse'?: StatusResponse;
}
/**
 * 
 * @export
 * @interface UpdateProspectRequest
 */
export interface UpdateProspectRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProspectRequest
     */
    'referralCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProspectRequest
     */
    'secret'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProspectResponse
 */
export interface UpdateProspectResponse {
    /**
     * 
     * @type {StatusResponse}
     * @memberof UpdateProspectResponse
     */
    'status'?: StatusResponse;
    /**
     * 
     * @type {string}
     * @memberof UpdateProspectResponse
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UpdateSessionRequest
 */
export interface UpdateSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionRequest
     */
    'referralCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionRequest
     */
    'sessionState'?: string;
}
/**
 * 
 * @export
 * @interface Validator
 */
export interface Validator {
    /**
     * 
     * @type {number}
     * @memberof Validator
     */
    'idDomandaDipendenza'?: number;
    /**
     * 
     * @type {number}
     * @memberof Validator
     */
    'idGroup'?: number;
    /**
     * 
     * @type {number}
     * @memberof Validator
     */
    'idRispostaDipendenza'?: number;
    /**
     * 
     * @type {string}
     * @memberof Validator
     */
    'idRispostaEsterna'?: string;
    /**
     * 
     * @type {string}
     * @memberof Validator
     */
    'idRispostaEsternaDipendenza'?: string;
    /**
     * 
     * @type {string}
     * @memberof Validator
     */
    'tipoDipendenza'?: string;
    /**
     * 
     * @type {number}
     * @memberof Validator
     */
    'idRisposta'?: number;
}
/**
 * 
 * @export
 * @interface VerifyReferralCodeRequest
 */
export interface VerifyReferralCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyReferralCodeRequest
     */
    'referralCode'?: string;
}

/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateProspectRequest} createProspectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProspect: async (createProspectRequest: CreateProspectRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProspectRequest' is not null or undefined
            assertParamExists('createProspect', 'createProspectRequest', createProspectRequest)
            const localVarPath = `/customer/public/create-prospect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProspectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} referralCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePraticaByReferralCode: async (referralCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralCode' is not null or undefined
            assertParamExists('deletePraticaByReferralCode', 'referralCode', referralCode)
            const localVarPath = `/customer/delete-pratica-by-referral-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (referralCode !== undefined) {
                localVarQueryParameter['referralCode'] = referralCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} idCustomer 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatiFatcaCrs: async (idCustomer: string, idIncarico: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idCustomer' is not null or undefined
            assertParamExists('getDatiFatcaCrs', 'idCustomer', idCustomer)
            // verify required parameter 'idIncarico' is not null or undefined
            assertParamExists('getDatiFatcaCrs', 'idIncarico', idIncarico)
            const localVarPath = `/customer/{idCustomer}/fatcacrs`
                .replace(`{${"idCustomer"}}`, encodeURIComponent(String(idCustomer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idIncarico !== undefined) {
                localVarQueryParameter['idIncarico'] = idIncarico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} referralCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinalizeOnboarding: async (referralCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referralCode' is not null or undefined
            assertParamExists('getFinalizeOnboarding', 'referralCode', referralCode)
            const localVarPath = `/customer/public/finalize-onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (referralCode !== undefined) {
                localVarQueryParameter['referralCode'] = referralCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recupero dello stato della sessione Invydio
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvydioSessionStatus: async (sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('getInvydioSessionStatus', 'sessionId', sessionId)
            const localVarPath = `/customer/public/invydio-session-status/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateSessionRequest} updateSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdateSession: async (updateSessionRequest: UpdateSessionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateSessionRequest' is not null or undefined
            assertParamExists('postUpdateSession', 'updateSessionRequest', updateSessionRequest)
            const localVarPath = `/customer/public/update-session-prospect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} idCustomer 
         * @param {DatiFatca} [datiFatca] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDatiFatcaCrsPost: async (idCustomer: string, datiFatca?: DatiFatca, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idCustomer' is not null or undefined
            assertParamExists('saveDatiFatcaCrsPost', 'idCustomer', idCustomer)
            const localVarPath = `/customer/{idCustomer}/fatcacrs`
                .replace(`{${"idCustomer"}}`, encodeURIComponent(String(idCustomer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(datiFatca, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateProspectRequest} updateProspectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProspect: async (updateProspectRequest: UpdateProspectRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProspectRequest' is not null or undefined
            assertParamExists('updateProspect', 'updateProspectRequest', updateProspectRequest)
            const localVarPath = `/customer/public/update-prospect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProspectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifica del referral code
         * @param {VerifyReferralCodeRequest} verifyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyReferralCode: async (verifyReferralCodeRequest: VerifyReferralCodeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyReferralCodeRequest' is not null or undefined
            assertParamExists('verifyReferralCode', 'verifyReferralCodeRequest', verifyReferralCodeRequest)
            const localVarPath = `/customer/public/verify-referral-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyReferralCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateProspectRequest} createProspectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProspect(createProspectRequest: CreateProspectRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProspectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProspect(createProspectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} referralCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePraticaByReferralCode(referralCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePraticaByReferralCode(referralCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} idCustomer 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatiFatcaCrs(idCustomer: string, idIncarico: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatiFatca>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatiFatcaCrs(idCustomer, idIncarico, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} referralCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFinalizeOnboarding(referralCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FinalizeOnboardingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFinalizeOnboarding(referralCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Recupero dello stato della sessione Invydio
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvydioSessionStatus(sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvydioSessionStatus(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateSessionRequest} updateSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUpdateSession(updateSessionRequest: UpdateSessionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUpdateSession(updateSessionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} idCustomer 
         * @param {DatiFatca} [datiFatca] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDatiFatcaCrsPost(idCustomer: string, datiFatca?: DatiFatca, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDatiFatcaCrsPost(idCustomer, datiFatca, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateProspectRequest} updateProspectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProspect(updateProspectRequest: UpdateProspectRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProspectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProspect(updateProspectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifica del referral code
         * @param {VerifyReferralCodeRequest} verifyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyReferralCode(verifyReferralCodeRequest: VerifyReferralCodeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralCodeByPraticaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyReferralCode(verifyReferralCodeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateProspectRequest} createProspectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProspect(createProspectRequest: CreateProspectRequest, options?: any): AxiosPromise<CreateProspectResponse> {
            return localVarFp.createProspect(createProspectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} referralCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePraticaByReferralCode(referralCode: string, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.deletePraticaByReferralCode(referralCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} idCustomer 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatiFatcaCrs(idCustomer: string, idIncarico: string, options?: any): AxiosPromise<DatiFatca> {
            return localVarFp.getDatiFatcaCrs(idCustomer, idIncarico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} referralCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinalizeOnboarding(referralCode: string, options?: any): AxiosPromise<FinalizeOnboardingResponse> {
            return localVarFp.getFinalizeOnboarding(referralCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Recupero dello stato della sessione Invydio
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvydioSessionStatus(sessionId: string, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.getInvydioSessionStatus(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateSessionRequest} updateSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdateSession(updateSessionRequest: UpdateSessionRequest, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.postUpdateSession(updateSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} idCustomer 
         * @param {DatiFatca} [datiFatca] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDatiFatcaCrsPost(idCustomer: string, datiFatca?: DatiFatca, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.saveDatiFatcaCrsPost(idCustomer, datiFatca, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateProspectRequest} updateProspectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProspect(updateProspectRequest: UpdateProspectRequest, options?: any): AxiosPromise<UpdateProspectResponse> {
            return localVarFp.updateProspect(updateProspectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifica del referral code
         * @param {VerifyReferralCodeRequest} verifyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyReferralCode(verifyReferralCodeRequest: VerifyReferralCodeRequest, options?: any): AxiosPromise<ReferralCodeByPraticaResponse> {
            return localVarFp.verifyReferralCode(verifyReferralCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createProspect operation in CustomerApi.
 * @export
 * @interface CustomerApiCreateProspectRequest
 */
export interface CustomerApiCreateProspectRequest {
    /**
     * 
     * @type {CreateProspectRequest}
     * @memberof CustomerApiCreateProspect
     */
    readonly createProspectRequest: CreateProspectRequest
}

/**
 * Request parameters for deletePraticaByReferralCode operation in CustomerApi.
 * @export
 * @interface CustomerApiDeletePraticaByReferralCodeRequest
 */
export interface CustomerApiDeletePraticaByReferralCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiDeletePraticaByReferralCode
     */
    readonly referralCode: string
}

/**
 * Request parameters for getDatiFatcaCrs operation in CustomerApi.
 * @export
 * @interface CustomerApiGetDatiFatcaCrsRequest
 */
export interface CustomerApiGetDatiFatcaCrsRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiGetDatiFatcaCrs
     */
    readonly idCustomer: string

    /**
     * 
     * @type {string}
     * @memberof CustomerApiGetDatiFatcaCrs
     */
    readonly idIncarico: string
}

/**
 * Request parameters for getFinalizeOnboarding operation in CustomerApi.
 * @export
 * @interface CustomerApiGetFinalizeOnboardingRequest
 */
export interface CustomerApiGetFinalizeOnboardingRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiGetFinalizeOnboarding
     */
    readonly referralCode: string
}

/**
 * Request parameters for getInvydioSessionStatus operation in CustomerApi.
 * @export
 * @interface CustomerApiGetInvydioSessionStatusRequest
 */
export interface CustomerApiGetInvydioSessionStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiGetInvydioSessionStatus
     */
    readonly sessionId: string
}

/**
 * Request parameters for postUpdateSession operation in CustomerApi.
 * @export
 * @interface CustomerApiPostUpdateSessionRequest
 */
export interface CustomerApiPostUpdateSessionRequest {
    /**
     * 
     * @type {UpdateSessionRequest}
     * @memberof CustomerApiPostUpdateSession
     */
    readonly updateSessionRequest: UpdateSessionRequest
}

/**
 * Request parameters for saveDatiFatcaCrsPost operation in CustomerApi.
 * @export
 * @interface CustomerApiSaveDatiFatcaCrsPostRequest
 */
export interface CustomerApiSaveDatiFatcaCrsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerApiSaveDatiFatcaCrsPost
     */
    readonly idCustomer: string

    /**
     * 
     * @type {DatiFatca}
     * @memberof CustomerApiSaveDatiFatcaCrsPost
     */
    readonly datiFatca?: DatiFatca
}

/**
 * Request parameters for updateProspect operation in CustomerApi.
 * @export
 * @interface CustomerApiUpdateProspectRequest
 */
export interface CustomerApiUpdateProspectRequest {
    /**
     * 
     * @type {UpdateProspectRequest}
     * @memberof CustomerApiUpdateProspect
     */
    readonly updateProspectRequest: UpdateProspectRequest
}

/**
 * Request parameters for verifyReferralCode operation in CustomerApi.
 * @export
 * @interface CustomerApiVerifyReferralCodeRequest
 */
export interface CustomerApiVerifyReferralCodeRequest {
    /**
     * 
     * @type {VerifyReferralCodeRequest}
     * @memberof CustomerApiVerifyReferralCode
     */
    readonly verifyReferralCodeRequest: VerifyReferralCodeRequest
}

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @param {CustomerApiCreateProspectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createProspect(requestParameters: CustomerApiCreateProspectRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createProspect(requestParameters.createProspectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiDeletePraticaByReferralCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public deletePraticaByReferralCode(requestParameters: CustomerApiDeletePraticaByReferralCodeRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).deletePraticaByReferralCode(requestParameters.referralCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiGetDatiFatcaCrsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getDatiFatcaCrs(requestParameters: CustomerApiGetDatiFatcaCrsRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getDatiFatcaCrs(requestParameters.idCustomer, requestParameters.idIncarico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiGetFinalizeOnboardingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getFinalizeOnboarding(requestParameters: CustomerApiGetFinalizeOnboardingRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getFinalizeOnboarding(requestParameters.referralCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recupero dello stato della sessione Invydio
     * @param {CustomerApiGetInvydioSessionStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getInvydioSessionStatus(requestParameters: CustomerApiGetInvydioSessionStatusRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getInvydioSessionStatus(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiPostUpdateSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public postUpdateSession(requestParameters: CustomerApiPostUpdateSessionRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).postUpdateSession(requestParameters.updateSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiSaveDatiFatcaCrsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public saveDatiFatcaCrsPost(requestParameters: CustomerApiSaveDatiFatcaCrsPostRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).saveDatiFatcaCrsPost(requestParameters.idCustomer, requestParameters.datiFatca, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiUpdateProspectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateProspect(requestParameters: CustomerApiUpdateProspectRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateProspect(requestParameters.updateProspectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifica del referral code
     * @param {CustomerApiVerifyReferralCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public verifyReferralCode(requestParameters: CustomerApiVerifyReferralCodeRequest, options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).verifyReferralCode(requestParameters.verifyReferralCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServizioApi - axios parameter creator
 * @export
 */
export const ServizioApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} codiceFiscale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPraticaSelf: async (codiceFiscale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codiceFiscale' is not null or undefined
            assertParamExists('getPraticaSelf', 'codiceFiscale', codiceFiscale)
            const localVarPath = `/servizio/{codiceFiscale}/pratica-self`
                .replace(`{${"codiceFiscale"}}`, encodeURIComponent(String(codiceFiscale)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} codicePratica 
         * @param {MifidCompileTypeRequest} mifidCompileTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdateMifidCompileType: async (codicePratica: string, mifidCompileTypeRequest: MifidCompileTypeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codicePratica' is not null or undefined
            assertParamExists('postUpdateMifidCompileType', 'codicePratica', codicePratica)
            // verify required parameter 'mifidCompileTypeRequest' is not null or undefined
            assertParamExists('postUpdateMifidCompileType', 'mifidCompileTypeRequest', mifidCompileTypeRequest)
            const localVarPath = `/servizio/{codicePratica}/update-mifid-compile-type`
                .replace(`{${"codicePratica"}}`, encodeURIComponent(String(codicePratica)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mifidCompileTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServizioApi - functional programming interface
 * @export
 */
export const ServizioApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServizioApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} codiceFiscale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPraticaSelf(codiceFiscale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PraticaSelfResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPraticaSelf(codiceFiscale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} codicePratica 
         * @param {MifidCompileTypeRequest} mifidCompileTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUpdateMifidCompileType(codicePratica: string, mifidCompileTypeRequest: MifidCompileTypeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUpdateMifidCompileType(codicePratica, mifidCompileTypeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServizioApi - factory interface
 * @export
 */
export const ServizioApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServizioApiFp(configuration)
    return {
        /**
         * 
         * @param {string} codiceFiscale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPraticaSelf(codiceFiscale: string, options?: any): AxiosPromise<PraticaSelfResponse> {
            return localVarFp.getPraticaSelf(codiceFiscale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} codicePratica 
         * @param {MifidCompileTypeRequest} mifidCompileTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUpdateMifidCompileType(codicePratica: string, mifidCompileTypeRequest: MifidCompileTypeRequest, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.postUpdateMifidCompileType(codicePratica, mifidCompileTypeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPraticaSelf operation in ServizioApi.
 * @export
 * @interface ServizioApiGetPraticaSelfRequest
 */
export interface ServizioApiGetPraticaSelfRequest {
    /**
     * 
     * @type {string}
     * @memberof ServizioApiGetPraticaSelf
     */
    readonly codiceFiscale: string
}

/**
 * Request parameters for postUpdateMifidCompileType operation in ServizioApi.
 * @export
 * @interface ServizioApiPostUpdateMifidCompileTypeRequest
 */
export interface ServizioApiPostUpdateMifidCompileTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof ServizioApiPostUpdateMifidCompileType
     */
    readonly codicePratica: string

    /**
     * 
     * @type {MifidCompileTypeRequest}
     * @memberof ServizioApiPostUpdateMifidCompileType
     */
    readonly mifidCompileTypeRequest: MifidCompileTypeRequest
}

/**
 * ServizioApi - object-oriented interface
 * @export
 * @class ServizioApi
 * @extends {BaseAPI}
 */
export class ServizioApi extends BaseAPI {
    /**
     * 
     * @param {ServizioApiGetPraticaSelfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServizioApi
     */
    public getPraticaSelf(requestParameters: ServizioApiGetPraticaSelfRequest, options?: AxiosRequestConfig) {
        return ServizioApiFp(this.configuration).getPraticaSelf(requestParameters.codiceFiscale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ServizioApiPostUpdateMifidCompileTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServizioApi
     */
    public postUpdateMifidCompileType(requestParameters: ServizioApiPostUpdateMifidCompileTypeRequest, options?: AxiosRequestConfig) {
        return ServizioApiFp(this.configuration).postUpdateMifidCompileType(requestParameters.codicePratica, requestParameters.mifidCompileTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SurveyApi - axios parameter creator
 * @export
 */
export const SurveyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} idCliente 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmlAnswers: async (idCliente: string, idIncarico: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idCliente' is not null or undefined
            assertParamExists('getAmlAnswers', 'idCliente', idCliente)
            // verify required parameter 'idIncarico' is not null or undefined
            assertParamExists('getAmlAnswers', 'idIncarico', idIncarico)
            const localVarPath = `/survey/aml/{idCliente}/get`
                .replace(`{${"idCliente"}}`, encodeURIComponent(String(idCliente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idIncarico !== undefined) {
                localVarQueryParameter['idIncarico'] = idIncarico;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} imageCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages: async (imageCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageCode' is not null or undefined
            assertParamExists('getImages', 'imageCode', imageCode)
            const localVarPath = `/survey/mifid/external/image/{imageCode}`
                .replace(`{${"imageCode"}}`, encodeURIComponent(String(imageCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} idCliente 
         * @param {string} idPratica 
         * @param {boolean} flagRiepilogo 
         * @param {string} tipoMifid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMifidV2Answers: async (idCliente: string, idPratica: string, flagRiepilogo: boolean, tipoMifid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idCliente' is not null or undefined
            assertParamExists('getMifidV2Answers', 'idCliente', idCliente)
            // verify required parameter 'idPratica' is not null or undefined
            assertParamExists('getMifidV2Answers', 'idPratica', idPratica)
            // verify required parameter 'flagRiepilogo' is not null or undefined
            assertParamExists('getMifidV2Answers', 'flagRiepilogo', flagRiepilogo)
            // verify required parameter 'tipoMifid' is not null or undefined
            assertParamExists('getMifidV2Answers', 'tipoMifid', tipoMifid)
            const localVarPath = `/survey/mifidv2/get/{idCliente}`
                .replace(`{${"idCliente"}}`, encodeURIComponent(String(idCliente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPratica !== undefined) {
                localVarQueryParameter['idPratica'] = idPratica;
            }

            if (flagRiepilogo !== undefined) {
                localVarQueryParameter['flagRiepilogo'] = flagRiepilogo;
            }

            if (tipoMifid !== undefined) {
                localVarQueryParameter['tipoMifid'] = tipoMifid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tipoMifid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMifidV2Template: async (tipoMifid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tipoMifid' is not null or undefined
            assertParamExists('getMifidV2Template', 'tipoMifid', tipoMifid)
            const localVarPath = `/survey/mifidv2/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tipoMifid !== undefined) {
                localVarQueryParameter['tipoMifid'] = tipoMifid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateExternal: async (templateType: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateType' is not null or undefined
            assertParamExists('getTemplateExternal', 'templateType', templateType)
            const localVarPath = `/survey/template/external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (templateType !== undefined) {
                localVarQueryParameter['templateType'] = templateType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} idCliente 
         * @param {PostMifidExternalMassiveRequest} postMifidExternalMassiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMifidExternalMassive: async (idCliente: string, postMifidExternalMassiveRequest: PostMifidExternalMassiveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idCliente' is not null or undefined
            assertParamExists('postMifidExternalMassive', 'idCliente', idCliente)
            // verify required parameter 'postMifidExternalMassiveRequest' is not null or undefined
            assertParamExists('postMifidExternalMassive', 'postMifidExternalMassiveRequest', postMifidExternalMassiveRequest)
            const localVarPath = `/survey/mifid/external/{idCliente}/massive`
                .replace(`{${"idCliente"}}`, encodeURIComponent(String(idCliente)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postMifidExternalMassiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SurveyRisposte} surveyRisposte 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMifidNoProfiling: async (surveyRisposte: SurveyRisposte, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyRisposte' is not null or undefined
            assertParamExists('postMifidNoProfiling', 'surveyRisposte', surveyRisposte)
            const localVarPath = `/survey/mifid/saveNoProfiling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyRisposte, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SurveyRisposte} [surveyRisposte] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAmlAnswersPost: async (surveyRisposte?: SurveyRisposte, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey/aml/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyRisposte, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tipoMifid 
         * @param {SurveyRisposteFull} [surveyRisposteFull] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMifidV2Full: async (tipoMifid: string, surveyRisposteFull?: SurveyRisposteFull, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tipoMifid' is not null or undefined
            assertParamExists('saveMifidV2Full', 'tipoMifid', tipoMifid)
            const localVarPath = `/survey/mifidv2/saveFull`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tipoMifid !== undefined) {
                localVarQueryParameter['tipoMifid'] = tipoMifid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyRisposteFull, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyApi - functional programming interface
 * @export
 */
export const SurveyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} idCliente 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAmlAnswers(idCliente: string, idIncarico: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyRisposte>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAmlAnswers(idCliente, idIncarico, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} imageCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImages(imageCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImages(imageCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} idCliente 
         * @param {string} idPratica 
         * @param {boolean} flagRiepilogo 
         * @param {string} tipoMifid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMifidV2Answers(idCliente: string, idPratica: string, flagRiepilogo: boolean, tipoMifid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyRisposte>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMifidV2Answers(idCliente, idPratica, flagRiepilogo, tipoMifid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tipoMifid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMifidV2Template(tipoMifid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Template>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMifidV2Template(tipoMifid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} templateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplateExternal(templateType: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormThematicAreaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplateExternal(templateType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} idCliente 
         * @param {PostMifidExternalMassiveRequest} postMifidExternalMassiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMifidExternalMassive(idCliente: string, postMifidExternalMassiveRequest: PostMifidExternalMassiveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostMifidExternalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMifidExternalMassive(idCliente, postMifidExternalMassiveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SurveyRisposte} surveyRisposte 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMifidNoProfiling(surveyRisposte: SurveyRisposte, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyRisposte>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMifidNoProfiling(surveyRisposte, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SurveyRisposte} [surveyRisposte] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAmlAnswersPost(surveyRisposte?: SurveyRisposte, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyRisposte>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAmlAnswersPost(surveyRisposte, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tipoMifid 
         * @param {SurveyRisposteFull} [surveyRisposteFull] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMifidV2Full(tipoMifid: string, surveyRisposteFull?: SurveyRisposteFull, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMifidV2Full(tipoMifid, surveyRisposteFull, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SurveyApi - factory interface
 * @export
 */
export const SurveyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyApiFp(configuration)
    return {
        /**
         * 
         * @param {string} idCliente 
         * @param {string} idIncarico 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAmlAnswers(idCliente: string, idIncarico: string, options?: any): AxiosPromise<SurveyRisposte> {
            return localVarFp.getAmlAnswers(idCliente, idIncarico, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} imageCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages(imageCode: string, options?: any): AxiosPromise<string> {
            return localVarFp.getImages(imageCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} idCliente 
         * @param {string} idPratica 
         * @param {boolean} flagRiepilogo 
         * @param {string} tipoMifid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMifidV2Answers(idCliente: string, idPratica: string, flagRiepilogo: boolean, tipoMifid: string, options?: any): AxiosPromise<SurveyRisposte> {
            return localVarFp.getMifidV2Answers(idCliente, idPratica, flagRiepilogo, tipoMifid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tipoMifid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMifidV2Template(tipoMifid: string, options?: any): AxiosPromise<Template> {
            return localVarFp.getMifidV2Template(tipoMifid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} templateType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateExternal(templateType: string, options?: any): AxiosPromise<FormThematicAreaResponse> {
            return localVarFp.getTemplateExternal(templateType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} idCliente 
         * @param {PostMifidExternalMassiveRequest} postMifidExternalMassiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMifidExternalMassive(idCliente: string, postMifidExternalMassiveRequest: PostMifidExternalMassiveRequest, options?: any): AxiosPromise<PostMifidExternalResponse> {
            return localVarFp.postMifidExternalMassive(idCliente, postMifidExternalMassiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SurveyRisposte} surveyRisposte 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMifidNoProfiling(surveyRisposte: SurveyRisposte, options?: any): AxiosPromise<SurveyRisposte> {
            return localVarFp.postMifidNoProfiling(surveyRisposte, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SurveyRisposte} [surveyRisposte] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAmlAnswersPost(surveyRisposte?: SurveyRisposte, options?: any): AxiosPromise<SurveyRisposte> {
            return localVarFp.saveAmlAnswersPost(surveyRisposte, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tipoMifid 
         * @param {SurveyRisposteFull} [surveyRisposteFull] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMifidV2Full(tipoMifid: string, surveyRisposteFull?: SurveyRisposteFull, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.saveMifidV2Full(tipoMifid, surveyRisposteFull, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAmlAnswers operation in SurveyApi.
 * @export
 * @interface SurveyApiGetAmlAnswersRequest
 */
export interface SurveyApiGetAmlAnswersRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetAmlAnswers
     */
    readonly idCliente: string

    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetAmlAnswers
     */
    readonly idIncarico: string
}

/**
 * Request parameters for getImages operation in SurveyApi.
 * @export
 * @interface SurveyApiGetImagesRequest
 */
export interface SurveyApiGetImagesRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetImages
     */
    readonly imageCode: string
}

/**
 * Request parameters for getMifidV2Answers operation in SurveyApi.
 * @export
 * @interface SurveyApiGetMifidV2AnswersRequest
 */
export interface SurveyApiGetMifidV2AnswersRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetMifidV2Answers
     */
    readonly idCliente: string

    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetMifidV2Answers
     */
    readonly idPratica: string

    /**
     * 
     * @type {boolean}
     * @memberof SurveyApiGetMifidV2Answers
     */
    readonly flagRiepilogo: boolean

    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetMifidV2Answers
     */
    readonly tipoMifid: string
}

/**
 * Request parameters for getMifidV2Template operation in SurveyApi.
 * @export
 * @interface SurveyApiGetMifidV2TemplateRequest
 */
export interface SurveyApiGetMifidV2TemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetMifidV2Template
     */
    readonly tipoMifid: string
}

/**
 * Request parameters for getTemplateExternal operation in SurveyApi.
 * @export
 * @interface SurveyApiGetTemplateExternalRequest
 */
export interface SurveyApiGetTemplateExternalRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyApiGetTemplateExternal
     */
    readonly templateType: string
}

/**
 * Request parameters for postMifidExternalMassive operation in SurveyApi.
 * @export
 * @interface SurveyApiPostMifidExternalMassiveRequest
 */
export interface SurveyApiPostMifidExternalMassiveRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyApiPostMifidExternalMassive
     */
    readonly idCliente: string

    /**
     * 
     * @type {PostMifidExternalMassiveRequest}
     * @memberof SurveyApiPostMifidExternalMassive
     */
    readonly postMifidExternalMassiveRequest: PostMifidExternalMassiveRequest
}

/**
 * Request parameters for postMifidNoProfiling operation in SurveyApi.
 * @export
 * @interface SurveyApiPostMifidNoProfilingRequest
 */
export interface SurveyApiPostMifidNoProfilingRequest {
    /**
     * 
     * @type {SurveyRisposte}
     * @memberof SurveyApiPostMifidNoProfiling
     */
    readonly surveyRisposte: SurveyRisposte
}

/**
 * Request parameters for saveAmlAnswersPost operation in SurveyApi.
 * @export
 * @interface SurveyApiSaveAmlAnswersPostRequest
 */
export interface SurveyApiSaveAmlAnswersPostRequest {
    /**
     * 
     * @type {SurveyRisposte}
     * @memberof SurveyApiSaveAmlAnswersPost
     */
    readonly surveyRisposte?: SurveyRisposte
}

/**
 * Request parameters for saveMifidV2Full operation in SurveyApi.
 * @export
 * @interface SurveyApiSaveMifidV2FullRequest
 */
export interface SurveyApiSaveMifidV2FullRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyApiSaveMifidV2Full
     */
    readonly tipoMifid: string

    /**
     * 
     * @type {SurveyRisposteFull}
     * @memberof SurveyApiSaveMifidV2Full
     */
    readonly surveyRisposteFull?: SurveyRisposteFull
}

/**
 * SurveyApi - object-oriented interface
 * @export
 * @class SurveyApi
 * @extends {BaseAPI}
 */
export class SurveyApi extends BaseAPI {
    /**
     * 
     * @param {SurveyApiGetAmlAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public getAmlAnswers(requestParameters: SurveyApiGetAmlAnswersRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).getAmlAnswers(requestParameters.idCliente, requestParameters.idIncarico, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiGetImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public getImages(requestParameters: SurveyApiGetImagesRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).getImages(requestParameters.imageCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiGetMifidV2AnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public getMifidV2Answers(requestParameters: SurveyApiGetMifidV2AnswersRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).getMifidV2Answers(requestParameters.idCliente, requestParameters.idPratica, requestParameters.flagRiepilogo, requestParameters.tipoMifid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiGetMifidV2TemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public getMifidV2Template(requestParameters: SurveyApiGetMifidV2TemplateRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).getMifidV2Template(requestParameters.tipoMifid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiGetTemplateExternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public getTemplateExternal(requestParameters: SurveyApiGetTemplateExternalRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).getTemplateExternal(requestParameters.templateType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiPostMifidExternalMassiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public postMifidExternalMassive(requestParameters: SurveyApiPostMifidExternalMassiveRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).postMifidExternalMassive(requestParameters.idCliente, requestParameters.postMifidExternalMassiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiPostMifidNoProfilingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public postMifidNoProfiling(requestParameters: SurveyApiPostMifidNoProfilingRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).postMifidNoProfiling(requestParameters.surveyRisposte, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiSaveAmlAnswersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public saveAmlAnswersPost(requestParameters: SurveyApiSaveAmlAnswersPostRequest = {}, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).saveAmlAnswersPost(requestParameters.surveyRisposte, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SurveyApiSaveMifidV2FullRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    public saveMifidV2Full(requestParameters: SurveyApiSaveMifidV2FullRequest, options?: AxiosRequestConfig) {
        return SurveyApiFp(this.configuration).saveMifidV2Full(requestParameters.tipoMifid, requestParameters.surveyRisposteFull, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UtilityApi - axios parameter creator
 * @export
 */
export const UtilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ElencoDominioRequest} [elencoDominioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDominio: async (elencoDominioRequest?: ElencoDominioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utility/dominio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(elencoDominioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilityApi - functional programming interface
 * @export
 */
export const UtilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ElencoDominioRequest} [elencoDominioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDominio(elencoDominioRequest?: ElencoDominioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElencoDominioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDominio(elencoDominioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UtilityApi - factory interface
 * @export
 */
export const UtilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilityApiFp(configuration)
    return {
        /**
         * 
         * @param {ElencoDominioRequest} [elencoDominioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDominio(elencoDominioRequest?: ElencoDominioRequest, options?: any): AxiosPromise<ElencoDominioResponse> {
            return localVarFp.getDominio(elencoDominioRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDominio operation in UtilityApi.
 * @export
 * @interface UtilityApiGetDominioRequest
 */
export interface UtilityApiGetDominioRequest {
    /**
     * 
     * @type {ElencoDominioRequest}
     * @memberof UtilityApiGetDominio
     */
    readonly elencoDominioRequest?: ElencoDominioRequest
}

/**
 * UtilityApi - object-oriented interface
 * @export
 * @class UtilityApi
 * @extends {BaseAPI}
 */
export class UtilityApi extends BaseAPI {
    /**
     * 
     * @param {UtilityApiGetDominioRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    public getDominio(requestParameters: UtilityApiGetDominioRequest = {}, options?: AxiosRequestConfig) {
        return UtilityApiFp(this.configuration).getDominio(requestParameters.elencoDominioRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


